<script lang="ts">
	import IconLabel from '$lib/components/atoms/iconlabel/IconLabel.svelte';

	type T = $$Generic<string>;

	interface Props {
		options: { key: T; label?: string; icon?: string }[];
		label?: string;
		hideTextOnMobile?: boolean;
		class?: string;
	}

	const {
		options,
		label,
		hideTextOnMobile = false,
		class: classes = '',
	}: Props = $props();

</script>

<div class="flex flex-col gap-1 text-sm text-coloredneutral">
	{#if label}
		{label}
	{/if}
	<div class={['flex gap-2', classes]}>
		<!-- eslint-disable-next-line svelte/require-each-key -->
		{#each options as { label, icon }}
			<div
				class="flex justify-center items-center text-md rd-2 px-2 h-9 gap-1 bg-neutral-soft text-transparent"
			>
				<IconLabel {icon} {label} hideLabelOnMobile={hideTextOnMobile} />
			</div>
		{/each}
	</div>
</div>
